import React, { useEffect } from "react";
import { useFormik } from "formik";
import api from "api";
import { popinfo } from "component/Fancybox/Fancybox";
import { useState } from "react";
import { connect } from "react-redux";
import fancybox from "component/Fancybox/Fancybox";
import BlockHeader from "component/BlockHeader/BlockHeader";
import { format } from 'date-fns';
import stateMap from "store/stateMap";
import update from 'immutability-helper';
import _ from "lodash";
import "./style.scss";
import { SkillFinder } from "component/SkillFinder";

const ProficiencyLevels = (props) => {
    return (
        <div className={`proficiency-selector-bar ${props.onClick && '--interactive'}`}>
            <span className={`plvl-selector plvl-5 ${props.proficiency && props.proficiency == 5 && 'active'}`} onClick={e => {e.preventDefault(); if(props.onClick) props.onClick.apply(null,[5]);}}><span className="plvl-bar"></span><span className="plvl-name">Expert</span></span>
            <span className={`plvl-selector plvl-4 ${props.proficiency && props.proficiency == 4 && 'active'}`} onClick={e => {e.preventDefault(); if(props.onClick) props.onClick.apply(null,[4]);}}><span className="plvl-bar"></span><span className="plvl-name">Experienced</span></span>
            <span className={`plvl-selector plvl-3 ${props.proficiency && props.proficiency == 3 && 'active'}`} onClick={e => {e.preventDefault(); if(props.onClick) props.onClick.apply(null,[3]);}}><span className="plvl-bar"></span><span className="plvl-name">Advanced</span></span>
            <span className={`plvl-selector plvl-2 ${props.proficiency && props.proficiency == 2 && 'active'}`} onClick={e => {e.preventDefault(); if(props.onClick) props.onClick.apply(null,[2]);}}><span className="plvl-bar"></span><span className="plvl-name">Intermediate</span></span>
            <span className={`plvl-selector plvl-1 ${props.proficiency && props.proficiency == 1 && 'active'}`} onClick={e => {e.preventDefault(); if(props.onClick) props.onClick.apply(null,[1]);}}><span className="plvl-bar"></span><span className="plvl-name">Novice</span></span>
        </div>
    )
}


const EditSkill = connect(stateMap)((props) => {

    const [skill, setSkill]                     = useState(props.skill);
    
    const [skillName, setSkillName]             = useState('');
    const [skillRef, setSkillRef]               = useState(props.skill ? props.skill : false);
    const [proficiency, setProficiency]         = useState(props.skill ? skill.Proficiency : 0);

    const SubmitSkill = (e) => {
        e.preventDefault();

        let SavingSkill = popinfo('loading', 'Saving Skill', '');

            api('/Profile/Skill', 'post', {
                SkillName       : skillName
                ,SkillIDRef     : skillRef.SkillID
                ,Proficiency    : proficiency
                ,UserSkillID    : props.skill ? props.skill.UserSkillID : 0
            }, 'Bearer ' + props.auth.token)
                .then((response) => {

                    SavingSkill.close();

                    props.onSubmit.apply(null, [response.skill]);

                })
                .catch(error => {
                    popinfo('error', 'Saving Skill', error, {}, SavingSkill)
                })
    }

    return (
        <div className="w-640">
            <form action="" className="generic-form" onSubmit={SubmitSkill}>
                <div className="form-group">
                    <label htmlFor="exp-title">Skill Name</label>
                    {
                        !props.skill ?
                        <SkillFinder
                            onTextChange={ (e) => {
                                setSkillRef(false);
                            }}
                            onTextBlur={ e => {
                                setSkillName(e.target.value);
                            }}
                            onPillSelected={skill => {
                                setSkillRef(skill);
                            }}
                        /> : 
                        <span className="bold">{props.skill.SkillName}</span>
                    }
                </div>
                
                <div className="form-group">
                    <label htmlFor="" className="label">Proficiency</label>
                    <ProficiencyLevels proficiency={proficiency} onClick={proficiency => {
                        setProficiency(proficiency);
                    }}/>
                </div>
                <div className="form-group text-right">
                    <input className="btn btn-orange" value="Add" type="submit"/>
                </div>
            </form>
        </div>
    )
})

export { EditSkill, ProficiencyLevels }